<template>
  <div id="wrapper">
    <Nav :message="message" />
    <AlbumList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import AlbumList from '@/components/er/AlbumList.vue'

export default {
  name: 'Album',
  props: ['message'],
  components: {
    Nav,
    AlbumList
  }
}
</script>